"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandMenuSubMenu = void 0;
const react_1 = __importStar(require("react"));
const CommandMenuItems_1 = require("../CommanMenuItems/CommandMenuItems");
const getAdditionalContentNode_1 = require("../../helpers/getAdditionalContentNode");
const controls_1 = require("../../../controls");
const Menu_1 = require("../../../Menu");
const Popover_1 = require("../../../Popover");
exports.CommandMenuSubMenu = react_1.default.memo(function CommandMenuSubMenu({ level, menuItem, menuItemsRef, handleHide, otherOpenSubMenuOfThisLevel }) {
    const renderControl = (0, react_1.useCallback)((renderControlProps) => {
        if (menuItem.renderControl) {
            return menuItem.renderControl(renderControlProps);
        }
        const { button: { ref }, actions, isActive } = renderControlProps;
        return (react_1.default.createElement(Menu_1.MenuItem, { "data-selector-id": `command-menu-submenu-${menuItem.id || menuItem.text}`, hasSubmenu: true, isActive: menuItem.isActive || isActive, disabled: menuItem.disabled, icon: menuItem.icon, onMouseDown: (e) => {
                var _a;
                e.preventDefault();
                e.stopPropagation();
                if (!menuItem.disabled) {
                    actions.show();
                    (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick) === null || _a === void 0 ? void 0 : _a.call(menuItem, e);
                }
            }, ref: ref }, menuItem.text));
    }, [menuItem]);
    const renderPopover = (0, react_1.useCallback)(({ popover, content }) => {
        if (level < menuItemsRef.current.length) {
            menuItemsRef.current = menuItemsRef.current.slice(0, level);
        }
        menuItemsRef.current.push(popover.ref);
        return react_1.default.createElement(Menu_1.Menu, Object.assign({}, popover), content);
    }, [level, menuItemsRef]);
    const renderContent = (0, react_1.useCallback)((renderContentSubmenuProps) => {
        otherOpenSubMenuOfThisLevel.hide();
        otherOpenSubMenuOfThisLevel.hide = renderContentSubmenuProps.actions.hide;
        return (react_1.default.createElement(CommandMenuItems_1.CommandMenuItems, { level: level + 1, menuItems: menuItem.items, renderContentProps: renderContentSubmenuProps, menuItemsRef: menuItemsRef, handleHide: handleHide }));
    }, [handleHide, level, menuItem.items, menuItemsRef, otherOpenSubMenuOfThisLevel]);
    const popoverConfig = (0, react_1.useMemo)(() => [
        { xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.insideTop, offsetY: -1 },
        { xAxis: Popover_1.X_AXIS.outsideRight, yAxis: Popover_1.Y_AXIS.insideBottom, offsetY: 1 },
        {
            xAxis: Popover_1.X_AXIS.outsideLeft,
            yAxis: Popover_1.Y_AXIS.insideTop,
            offsetX: 0,
            offsetY: -1
        }
    ], []);
    const handleGetAdditionalContentNode = (0, react_1.useCallback)(() => (0, getAdditionalContentNode_1.getAdditionalContentNode)(menuItemsRef), [menuItemsRef]);
    return (0, controls_1.useDropdown)({
        popoverConfig: popoverConfig,
        getAdditionalContentNode: handleGetAdditionalContentNode,
        onOutsideClick: handleHide,
        renderControl,
        renderPopover,
        renderContent
    })[0];
});
//# sourceMappingURL=CommandMenuSubMenu.js.map